import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { CarrierDto, ShipViaDto } from "@insite/client-framework/Types/ApiModels";
import RfqQuoteDetailsNewState from "@tJohnstonCompanies/Handlers/RFQQuoteDetails/RFQQUoteDetailsNewState";
import { Draft } from "immer";

const initialState: RfqQuoteDetailsNewState = {
    carrier: undefined,
};

const customState = createTypedReducerWithImmer(initialState, {
    "Custom/RfqQuoteDetailsNew/SetCarrier": (
        draft: Draft<RfqQuoteDetailsNewState>,
        action: { carrier?: CarrierDto; iseditable?: boolean },
    ) => {
        draft.carrier = action.carrier;
        draft.iseditable = action.iseditable;
    },
    "Custom/RfqQuoteDetailsNew/SetShipVia": (
        draft: Draft<RfqQuoteDetailsNewState>,
        action: { shipVia?: ShipViaDto; iseditable?: boolean },
    ) => {
        draft.shipVia = action.shipVia;
        draft.iseditable = action.iseditable;
    },
    "Custom/RfqQuoteDetailsNew/SetAccountNumber": (
        draft: Draft<RfqQuoteDetailsNewState>,
        action: { accountNumber?: string; iseditable?: boolean },
    ) => {
        draft.accountNumber = action.accountNumber;
        draft.iseditable = action.iseditable;
    },
});

(reducers as any).customState = customState;

export type CustomState = {
    customState: RfqQuoteDetailsNewState;
} & ApplicationState;

type Reducers = {
    customState: typeof customState;
};

export type CustomActions = Parameters<Reducers[keyof Reducers]>[1] | AnyAction;
